<template>
  <div id="snapshotContainer" class="row">
    <div class="col-sm-12">
      <div id="chartWrapper">
        <div
          id="chartContainer"
          style="height: 370px; width: 100%;"
        ></div>
        <div v-if="!forExport" class="chartOverlay">
          <img src="../../public/img/logo.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {defaultChartOptions, rangeKeys} from "../constants";
  import EventBus from "../EventBus";
  const poly = [{"x":1.020124819960163,"y":40.909090909090914},{"x":1.2672138766979186,"y":36.36363636363637},{"x":1.5143029334356743,"y":33.333333333333336},{"x":1.7049144914905145,"y":30.90909090909091},{"x":1.902585736880719,"y":29.090909090909093},{"x":2.086137607600195,"y":26.969696969696972},{"x":2.086137607600195,"y":26.969696969696972},{"x":2.389704163020866,"y":25.454545454545457},{"x":2.636793219758622,"y":24.545454545454547},{"x":2.8980016511671063,"y":23.93939393939394},{"x":3.2156875812585066,"y":24.242424242424242},{"x":3.5474928860206356,"y":25.454545454545457},{"x":3.752223818746205,"y":26.060606060606062},{"x":3.971074126142503,"y":26.969696969696972},{"x":4.161685684197343,"y":28.484848484848488},{"x":4.437013490276557,"y":30.60606060606061},{"x":4.747639733032592,"y":34.24242424242424},{"x":4.980609415099619,"y":36.96969696969697},{"x":5.333593781867841,"y":44.24242424242424},{"x":5.5383247145934105,"y":49.6969696969697},{"x":5.714816897977522,"y":59.3939393939394},{"x":5.785413771331166,"y":66.66666666666667},{"x":5.74305564731898,"y":73.63636363636364},{"x":5.608921587947055,"y":77.87878787878789},{"x":5.361832531209299,"y":80},{"x":5.185340347825188,"y":80.30303030303031},{"x":4.96649004042889,"y":78.7878787878788},{"x":4.740580045697228,"y":77.27272727272728},{"x":4.528789425636294,"y":76.06060606060606},{"x":4.309939118239996,"y":74.24242424242425},{"x":4.07696943617297,"y":73.03030303030303},{"x":3.8087013174291204,"y":71.21212121212122},{"x":3.5404331986852715,"y":68.7878787878788},{"x":3.222747268593871,"y":66.96969696969697},{"x":2.968598524520751,"y":66.36363636363637},{"x":2.5520769717342486,"y":66.36363636363637},{"x":2.2343910416428483,"y":67.57575757575758},{"x":1.853167925533168,"y":69.39393939393939},{"x":1.4931238714295811,"y":72.12121212121212},{"x":1.1189604426552653,"y":74.54545454545455},{"x":0.8224535745699584,"y":76.06060606060606},{"x":0.6177226418443893,"y":74.84848484848486},{"x":0.49770795714319366,"y":68.7878787878788},{"x":0.5118273318139226,"y":60.60606060606061},{"x":0.5541854558261092,"y":56.06060606060606},{"x":0.6459613911858472,"y":51.81818181818182},{"x":0.7589163885516783,"y":47.57575757575758},{"x":0.8930504479236029,"y":43.63636363636364},{"x":0.9707070086126118,"y":41.81818181818182}]
  const phonemes = [{"x": 1.366049499393021, "y": 36.36363636363637}, {"x": 1.224855752685732, "y": 41.515151515151516}, {"x": 0.7730357632224072, "y": 53.03030303030303}, {"x": 1.224855752685732, "y": 53.333333333333336}, {"x": 1.3519301247222921, "y": 57.57575757575758}, {"x": 1.1895573160089097, "y": 61.81818181818182}, {"x": 1.366049499393021, "y": 47.27272727272727}, {"x": 1.5354819954417678, "y": 53.03030303030303}, {"x": 1.8108098015209813, "y": 30.60606060606061}, {"x": 1.7684516775087946, "y": 35.151515151515156}, {"x": 2.177913542959933, "y": 37.87878787878788}, {"x": 2.2273313543074837, "y": 45.45454545454546}, {"x": 2.4885397857159686, "y": 39.09090909090909}, {"x": 2.7073900931122665, "y": 33.93939393939394}, {"x": 2.8980016511671063, "y": 47.27272727272727}, {"x": 3.0180163358683023, "y": 62.42424242424243}, {"x": 3.420418513984076, "y": 43.333333333333336}, {"x": 3.5898510100328225, "y": 54.84848484848485}, {"x": 3.356881327965796, "y": 57.57575757575758}, {"x": 4.429953802941192, "y": 63.63636363636364}, {"x": 4.528789425636294, "y": 68.18181818181819}, {"x": 4.980609415099619, "y": 56.969696969696976}, {"x": 5.213579097166646, "y": 56.66666666666667}, {"x": 5.044146601117899, "y": 62.42424242424243}]
  const letters = ['E', 'NG', 'J', 'M', 'V', 'Z', 'N', 'DB', 'U', 'L', 'O', 'I', 'A', 'R', 'CH', 'P', 'SH', 'G', 'H', 'K', 'T', 'F', 'S', 'TH']


  export default {
    name: "Chart",
    mounted() {
      this.$nextTick(this.drawChart)
      this.$nextTick(() => {
        window.addEventListener('resize', this.debounce(this.onResize, 100));
      })

      EventBus.$on('showOnly', this.showOnly)
    },
    props: {
      showAudiogram: {
        default: false
      },
      showClassifications: {
        default: false
      },
      forExport: {
        default: false
      }
    },
    data() {
      return {
        chart: null,
        labels: [
          {
            text: 'Soft',
            top: p => this.chart.axisY[0].convertValueToPixel(5) - (p.clientHeight / 2) + "px",
            left: p => this.chart.axisX[0].convertValueToPixel(6) + 16 + "px"
          },
          {
            text: 'Loud',
            top: p => this.chart.axisY[0].convertValueToPixel(95) - (p.clientHeight / 2) + "px",
            left: p => this.chart.axisX[0].convertValueToPixel(6) + 16 + "px"
          },
          {
            text: 'Low pitched frequencies',
            top: p => this.chart.axisY[0].convertValueToPixel(100) + 30 + "px",
            left: p => this.chart.axisX[0].convertValueToPixel(0) + 20 + "px"
          },
          {
            text: 'High pitched frequencies',
            top: p => this.chart.axisY[0].convertValueToPixel(100) + 30 + "px",
            left: p => this.chart.axisX[0].convertValueToPixel(6) - p.clientWidth + "px"
          },
        ],
        worst: 0,
        paragraphs: [],
        classificationMap: [
          {key: 'normal', threshold: 0},
          {key: 'slight', threshold: 16},
          {key: 'mild', threshold: 34},
          {key: 'moderate', threshold: 49},
          {key: 'severe', threshold: 65},
          {key: 'profound', threshold: 81},
        ],
      }
    },
    methods: {
      drawChart() {
        let left = []
        let right = []

        const {resultsL, resultsR} = this.$store.state
        // let resultsL = {
        //   '125Hz': 50,
        //   '1kHz': 50,
        //   '250Hz': 0,
        //   '2kHz': 50,
        //   '4kHz': 0,
        //   '500Hz': 50,
        //   '8kHz': 50,
        //
        // }
        // let resultsR = {
        //   '125Hz': 0,
        //   '1kHz': 80,
        //   '250Hz': 0,
        //   '2kHz': 50,
        //   '4kHz': 50,
        //   '500Hz': 0,
        //   '8kHz': 50,
        // }

        rangeKeys.forEach((tone, i) => {
          left.push({label: tone, x: i, y: resultsL[tone]})
          right.push({label: tone, x: i, y: resultsR[tone]})

          if (resultsL[tone] >= 16) EventBus.$emit('newAnomaly', {side: 'L', tone})

          if (resultsR[tone] >= 16) EventBus.$emit('newAnomaly', {side: 'R', tone})

          this.classificationMap.forEach(({threshold, key}) => {
            if ((Math.max(resultsL[tone], resultsR[tone]) >= threshold) && threshold > this.worst) {
              this.worst = threshold
              EventBus.$emit('updateClassification', key)
            }
          })
        })
        this.chart = new CanvasJS.Chart("chartContainer", {
          interactivityEnabled: !this.showAudiogram,
          animationEnabled: true,
          backgroundColor: "transparent",
          axisY: {
            title: "%",
            includeZero: false,
            minimum: 0,
            maximum: 100,
            reversed: true,
            stripLines: false,
            ...defaultChartOptions

          },
          axisX: {
            minimum: 0,
            maximum: 6,
            gridThickness: 1,
            ...defaultChartOptions
          },
          legend: {
            cursor: "pointer",
            fontSize: 16,
            itemclick: this.toggleDataSeries,
          },
          toolTip: {
            shared: true,
          },
          data: [
            {
              name: "Left",
              type: "line",
              dataPoints: left
            },
            {
              name: "Right",
              type: "line",
              dataPoints: right,
              markerType: 'cross'
            }
          ],
        })

        //HOW TO ADD TEXT TO CHARTS
        // chart.addTo("data", {
        //   type: "scatter",
        //   markerSize: 0,
        //   highlightEnabled:false,
        //   dataPoints: [
        //     { x: new Date(2012, 01, 15), y: 40, indexLabel: "▲ - 16" },
        //     { x: new Date(2012, 02, 15), y: 40, indexLabel: "▲ - 14" }
        //   ]
        // });

        this.chart.render()
        EventBus.$emit('afterCharts', {chart: this.chart})
        this.showClassifications && this.drawClassifications()

        this.$nextTick(() => {
          let elem = document.querySelector('.canvasjs-chart-credit');
          elem.parentNode.removeChild(elem);
        })

        this.labels.forEach(({text, top, left}) => {
          let paragraph = document.createElement("p")
          paragraph.innerHTML = text
          document.getElementById("chartContainer").appendChild(paragraph)
          paragraph.style.position = "absolute"
          paragraph.style.color = "rgba(0, 0, 0, .3)"
          paragraph.style.fontFamily = "Azo Sans regular"
          paragraph.style.fontSize = "14px"
          paragraph.style.top = top(paragraph)
          paragraph.style.left = left(paragraph)
          if (window.innerWidth <= 550) {
            paragraph.style.display = 'none'
          } else {
            paragraph.style.display = 'block'
          }
          this.paragraphs.push(paragraph)
        })
        this.showAudiogram && this.drawAudiogram()
      },

      toggleDataSeries(e) {
        e.dataSeries.visible = !(typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible);
        this.chart.render()
      },
      onResize(event, showText) {
        this.paragraphs.forEach((paragraph, i) => {
          paragraph.style.top = this.labels[i].top(paragraph)
          paragraph.style.left = this.labels[i].left(paragraph)
          if (window.innerWidth <= 550 && !showText) {
            paragraph.style.display = 'none'
          } else {
            paragraph.style.display = 'block'
          }
        })
        this.showAudiogram && this.drawAudiogram()
      },
      debounce(func, wait, immediate) {
        let timeout;
        return function () {
          let context = this, args = arguments;
          let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          let callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      },
      showOnly(key) {
        let toShow = {key: 'L', dataKey: 0}
        let toHide = {key: 'R', dataKey: 1}

        if (key === 'R') {
          toShow = {key: 'R', dataKey: 1}
          toHide = {key: 'L', dataKey: 0}
        }

        this.chart.options.data[toHide.dataKey].visible = false
        this.chart.options.data[toShow.dataKey].visible = true

        let input = {}
        input[toShow.key] = true
        input[toHide.key] = false
        this.$emit('input', input)

        this.chart.render()
        this.showAudiogram && this.drawAudiogram()
      },

      drawAudiogram() {
        let canvas = document.querySelectorAll(".canvasjs-chart-canvas")
        canvas = canvas[0]

        let ctx = canvas.getContext('2d')
        // ctx.clearRect(0, 0, canvas.width, canvas.height)
        this.chart.render()
        ctx.lineWidth = 1
        ctx.strokeStyle = 'black'

        ctx.beginPath()
        ctx.setLineDash([5, 5])
        poly.forEach(({x, y}) => {
          ctx.lineTo(this.chart.axisX[0].convertValueToPixel(x), this.chart.axisY[0].convertValueToPixel(y))
        })
        ctx.stroke()

        ctx.font = "12px Arial"

        letters.forEach((letter, i) => {
          ctx.fillText(
            letter,
            this.chart.axisX[0].convertValueToPixel(phonemes[i].x),
            this.chart.axisY[0].convertValueToPixel(phonemes[i].y)
          )
        })
      },
      drawClassifications() {
        const positions = [
          {position: 10, text: "Normal", color: "#73bca0"},
          {position: 28, text: "Slight", color: "#d6d147"},
          {position: 43, text: "Mild", color: "#f5ca5f"},
          {position: 59, text: "Moderate", color: "#d57940"},
          {position: 75, text: "Severe", color: "#dd5b55"},
          {position: 90, text: "Profound", color: "#962440"}
        ];

        positions.forEach(({position, text, color}) => {
          let paragraph = document.createElement("p")
          paragraph.innerHTML = text
          paragraph.classList = 'shit'
          document.getElementById("chartContainer").appendChild(paragraph)
          paragraph.style.position = "absolute"
          paragraph.style.color = color
          paragraph.style.fontFamily = "Azo Sans Bold"

          paragraph.style.fontSize = "13px"

          paragraph.style.top =
            this.chart.axisY[0].convertValueToPixel(position) - paragraph.clientHeight / 2 + "px"
          paragraph.style.left = (this.forExport ? 120 : 80) + "px"
        })

        let stripLines = []
        const linePositions = [16, 34, 49, 65, 81]
        linePositions.forEach(position => {
          stripLines.push({
            value: position,
            color: "#000",
            lineDashType: "dash",
            opacity: 0.5
          })
        })

        this.chart.options.axisY.stripLines = stripLines
        this.chart.render()
      }
    },
    beforeDestroy() {
      this.chart.destroy()
    }
  }
</script>
